<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>ИД *</span>
        <v-select
          outlined
          item-text="slotId"
          item-value="slotId"
          hide-details
          dense
          return-object
          :value="changeAdPlacement"
          :disabled="isLoading"
          :loading="isLoading"
          :items="adPlacements"

          @input="changeListItemHandler($event)"
        />
        <ErrorMessage :message="errorMessages.text" />
      </v-col>
    </v-row>
    <v-row v-if="changeAdPlacement">
      <v-row>
        <v-col cols="12">
          <span>Заголовок</span>
          <v-text-field disabled outlined v-model="changeAdPlacement.title" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span>Ширина блока</span>
          <v-text-field
            disabled
            outlined
            :error-messages="errorMessages.width"
            v-model.trim="changeAdPlacement.width"
          />
        </v-col>
        <v-col cols="6">
          <span>Высота блока</span>
          <v-text-field
            disabled
            outlined
            :error-messages="errorMessages.height"
            v-model.trim="changeAdPlacement.height"
          />
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import ErrorMessage from '@/components/error-messages/ErrorMessage'
import adPlacementsQuery from '@/services/gql/types/AdPlacements/queries/adPlacements.gql'
export default {
  name: 'AdPlacementWidget',
  components: { ErrorMessage },
  mixins: [dynamicListItemMix],
  data () {
    return {
      adPlacements: {},
      changeAdPlacement: null
    }
  },
  methods: {
    changeListItemHandler (payload) {
      this.changeAdPlacement = payload
      this.mixChangeListItemHandler(payload, 'adPlacement')
    }
  },
  apollo: {
    adPlacements: {
      query: adPlacementsQuery,
      fetchPolicy: 'network-only',
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-ad-placements' })
        } else {
          this.adPlacements = res?.data?.adPlacements?.list || null
        }
      }
    }
  },
  mounted () {
    this.changeAdPlacement = this.listItem?.data?.adPlacement || null
  }
}
</script>
